// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pop-up {
  position: absolute;
  top: 0%;
  /* left: 0%; */
  /* transform: translate(-50%, -50%); */
  /* transform: translate(-35%, -105%); */
  transform: translate(-27%, -95%);
  background-color: white;
  /* padding: 20px; */
  border-radius: 10px;
  box-shadow: 0px 0px 10px #333;
  z-index: 11;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 187px;
  right: 12px;
  padding: 6px 0px;
}

.pop-up-content {
  display: flex;
  flex-direction: column;
  align-items: center;
 
}

.productListing_mobile {
  display: none;
}

.productListing_desktop {
  display: block;
}

.inputs {
  display: none;
}

.cardBodyHeight {
  min-height: 80vh;
}

.searchDiv{
  border: 1px solid #0094ff;
}

.searchDiv select {
  font-size: 13px;
  font-weight: 600;
  background: #0094ff;
  color: white;
}

.searchDiv input{
  border: none;
  outline: none;
  font-size: 12px;
  
}



@media screen and (max-width: 768px) {
  .productListing_mobile {
    display: block;
  }

  .productListing_desktop {
    display: none;
  }

  .importingSection {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 15px;
  }

  .inputs_desktop {
    display: none;
  }

  .inputs {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .pop-up {
   
  }

  .multiselectdivision {
    border: 1px solid lightgray;
  }

  .multiselectdivision div ul li {
    list-style: none;

  }
}`, "",{"version":3,"sources":["webpack://./src/pages/NewmasterPage/Master.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,sCAAsC;EACtC,uCAAuC;EACvC,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;;AAEjB;;;;AAIA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;;EAEA;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;;EAElB;AACF","sourcesContent":[".pop-up {\n  position: absolute;\n  top: 0%;\n  /* left: 0%; */\n  /* transform: translate(-50%, -50%); */\n  /* transform: translate(-35%, -105%); */\n  transform: translate(-27%, -95%);\n  background-color: white;\n  /* padding: 20px; */\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px #333;\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 187px;\n  right: 12px;\n  padding: 6px 0px;\n}\n\n.pop-up-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n \n}\n\n.productListing_mobile {\n  display: none;\n}\n\n.productListing_desktop {\n  display: block;\n}\n\n.inputs {\n  display: none;\n}\n\n.cardBodyHeight {\n  min-height: 80vh;\n}\n\n.searchDiv{\n  border: 1px solid #0094ff;\n}\n\n.searchDiv select {\n  font-size: 13px;\n  font-weight: 600;\n  background: #0094ff;\n  color: white;\n}\n\n.searchDiv input{\n  border: none;\n  outline: none;\n  font-size: 12px;\n  \n}\n\n\n\n@media screen and (max-width: 768px) {\n  .productListing_mobile {\n    display: block;\n  }\n\n  .productListing_desktop {\n    display: none;\n  }\n\n  .importingSection {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    gap: 15px;\n  }\n\n  .inputs_desktop {\n    display: none;\n  }\n\n  .inputs {\n    margin-top: 10px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n\n  .pop-up {\n   \n  }\n\n  .multiselectdivision {\n    border: 1px solid lightgray;\n  }\n\n  .multiselectdivision div ul li {\n    list-style: none;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
